import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { media } from 'style/media';

/**
 * OnlyDesktop (div)
 */
export const OnlyDesktop = styled.div`
  display: block;
  ${media.desktop`
    display: none;
  `};
`;

OnlyDesktop.propTypes = {
  bypass: PropTypes.bool
};

/**
 * OnlyDesktop (div)
 */
export const Hidden = styled.div`
  opacity: 0;
  height: 0;
  width: 0;
  overflow: none;
  position: absolute;
`;
